'use client';

import noDataFound from '@/public/assets/iconv2/no-data-found.svg';
import Text from '@/src/components/common/text';
import { Button } from '@/src/shadcn/components/ui/button';
import { ArrowLeft, Home } from 'lucide-react';
import Image from 'next/image';
import Link from 'next/link';
import { useRouter } from 'next/navigation';
import { notFoundPageContent } from '../content/error/not-found-page';

const NotFoundPage = () => {
  const router = useRouter();

  const goBack = () => {
    router.back();
  };

  return (
    <div className="absolute inset-0 flex flex-col items-center justify-center w-full p-6">
      <div className="w-full">
        <div className="flex items-center justify-center mb-8">
          <Image src={noDataFound} alt="page-not-found" className="w-24 h-24 sm:w-36 sm:h-36" />
        </div>
        <Text type="h3" className="text-4xl! font-semibold text-center" content={notFoundPageContent.title} />
        <div className="space-y-2 text-center flex flex-col items-center justify-center mt-3 gap-4">
          <div className="flex items-center justify-center">
            <Text type="h3" className="text-xl sm:text-2xl text-muted-foreground">
              {notFoundPageContent.description}
            </Text>
          </div>

          <div className="flex flex-col sm:flex-row gap-4 items-center justify-center mt-8">
            <Button type="button" className="flex gap-2 items-center px-4 py-2" onClick={goBack} variant="outline">
              <ArrowLeft className="w-4 h-4" />
              <Text type="h3" className="text-lg" content={notFoundPageContent.btnGoBack} />
            </Button>

            <Button type="button" className="flex gap-2 items-center px-4 py-2" variant="default">
              <Link href="/" className="flex gap-2 items-center">
                <Home className="w-4 h-4" />
                <Text type="h3" className="text-lg" content={notFoundPageContent.btnGoHome} />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;
